import React from 'react';
import * as Styles from './HeaderDesignSection.styles';
import useLocale from '@/hooks/useLocale';
import { useStudio } from '@/hooks/studio';
import { ChipCheckbox, IconAdd, Tooltip } from 'gatorcomponents';
import { studioAnalytics } from '@/analytics/studio';
import { BLANK_DOCUMENT_ID, FILTER_CATEGORIES } from '../../studio.enum';

const HeaderDesignSection = ({
  isProPlan, selectedCategories, setSelectedCategories, templatesLoading, displayFilterCategories,
}) => {
  const { studio: studioLocale } = useLocale();
  const { openStudio } = useStudio();

  const handleButtonEditorClick = () => {
    studioAnalytics.openEditorClick();
    openStudio('new_document', BLANK_DOCUMENT_ID);
  };

  const categoriesChips = Object.keys(FILTER_CATEGORIES).map(key => ({
    id: FILTER_CATEGORIES[key],
    label: studioLocale.headerDesignSection.filterCategories[FILTER_CATEGORIES[key]],
    checked: selectedCategories && selectedCategories.includes(FILTER_CATEGORIES[key]),
    value: FILTER_CATEGORIES[key],
  }));

  const onMarkCategory = (value) => {
    const newSelectedCategories = selectedCategories && selectedCategories.includes(value)
      ? selectedCategories.filter(category => category !== value)
      : [...selectedCategories, value];

    setSelectedCategories(newSelectedCategories);
  };

  return (
    <Styles.Wrapper isProPlan={isProPlan} $flexRow={!displayFilterCategories}>
      <Styles.HeaderText data-testid="header-text">{studioLocale.headerDesignSection.headerText}</Styles.HeaderText>

      <Styles.BottomContent>
        {displayFilterCategories && (
          <Styles.ChipsList>
            {categoriesChips.map((chip, index) => (
              <ChipCheckbox
                index={index}
                key={chip.id}
                id={chip.id}
                label={chip.label}
                active={chip.checked}
                value={chip.value}
                onMark={() => onMarkCategory(chip.value)}
              />
            ))}
          </Styles.ChipsList>
        )}

        <Tooltip content={studioLocale.headerDesignSection.tooltip} preferredPosition="left" disableMobile="true">
          <Styles.ButtonEditor onClick={() => handleButtonEditorClick()} disabled={templatesLoading}>
            <IconAdd color={templatesLoading ? 'lowLight' : 'highPure'} />
          </Styles.ButtonEditor>
        </Tooltip>
      </Styles.BottomContent>
    </Styles.Wrapper>
  );
};

export default HeaderDesignSection;
